// Add button product Upsell

if (!customElements.get('single-product-upsell')) {
  customElements.define('single-product-upsell', class SingleProductUpsell extends HTMLElement {
    constructor() {
      super();
      // data
      this.upsellBundle = this.dataset.upsellBundle;
      this.upsellId = this.dataset.upsellId;
      this.upsellTitle = this.dataset.upsellTitle;
      this.upsellPrice = this.dataset.upsellPrice;
      this.upsellSaving = this.dataset.upsellSaving;
      this.currencySymbol = this.dataset.shopCurrencySymbol;

      // selectors
      this.button = this.querySelector('.button-upsell');
      this.upsellsCountWrapper = document.querySelector('.sticky-atc__upsells')
      this.upsellsDrawer = document.querySelector('.upsells-drawer')
      this.stickyAtcPriceArr = document.querySelectorAll('.sticky-atc__price');
      this.stickyAtcSavingArr = document.querySelectorAll('.sticky-atc__saving');
      this.upsellsCountEl = this.upsellsCountWrapper.querySelector('.upsells_count')
      this.upsellsList = this.upsellsDrawer.querySelector('ul')

      // state
      this.isItemAdded = false;

      // listeners
      this.button.addEventListener('click', this.onClick.bind(this));

      document.addEventListener('upsells:reset', () => {
        this.reset();
      });
    }

    reset() {
      // get count
      this.upsellsCount = Number(this.upsellsCountEl.innerHTML);
      // remove hidden class
      this.upsellsCountWrapper.classList.remove('hidden')

      // update upsell count based on action
      this.upsellsCount = 0;
      // update count
      this.upsellsCountEl.innerHTML = this.upsellsCount;

      // toggle state
      this.isItemAdded = false;

      // common updates
      this.updateUpsellList();
      this.button.innerHTML = this.isItemAdded ? 'remove' : 'add';
    }

    onClick() {
      // get count
      this.upsellsCount = Number(this.upsellsCountEl.innerHTML);
      // remove hidden class
      this.upsellsCountWrapper.classList.remove('hidden')

      // update upsell count based on action
      this.upsellsCount = this.isItemAdded ? this.upsellsCount - 1 : this.upsellsCount + 1;
      // update count
      this.upsellsCountEl.innerHTML = this.upsellsCount;

      // toggle state
      this.isItemAdded = !this.isItemAdded;

      // common updates
      this.updateUpsellList();
      this.updateStickyAtcPrice(true);
      this.button.innerHTML = this.isItemAdded ? 'remove' : 'add';
    }

    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    updateUpsellList() {
      // append li or remove, also add id as data attribute
      if (this.isItemAdded && this.upsellBundle !== 'true') {
        this.upsellsList.innerHTML += `<li data-upsell-quantity="1" data-upsell-price="${this.upsellPrice}" data-upsell-id="${this.upsellId}">${this.upsellTitle}</li>`
      } else {
        this.upsellsList.querySelectorAll(`[data-upsell-id="${this.upsellId}"]`).forEach(el => el.remove());
      }

      if (this.isItemAdded && this.upsellBundle === 'true') {
        this.bundleParts = this.querySelectorAll('.mini-bundle-part');

        this.upsellsList.innerHTML += `<li class="bundle-title">${this.upsellTitle}</li>`;

        const uuid = this.generateUUID();
        const bundleId = `mini_bundle_part_${uuid}`;

        let bundlePartsCount = 0
        this.bundleParts.forEach(part => {
          bundlePartsCount += Number(part.dataset.quantity);
        });

        this.bundleParts.forEach(part => {
          const partId = part.dataset.variantId;
          const partQuantity = part.dataset.quantity;
          const partTitle = part.dataset.variantTitle;
          const partPrice = part.dataset.price;
          const discountPercantage = part.dataset.discountPercantage;

          this.upsellsList.innerHTML += `<li class="hidden" data-bundle-id="${bundleId}" data-bundle-parts-count="${bundlePartsCount}" data-discount-percantage="${discountPercantage}" data-upsell-quantity="${partQuantity}" data-upsell-price="${partPrice}" data-upsell-id="${partId}">${partTitle}</li>`
        });

      } else {
        if (!this.upsellsList.querySelector('.bundle-title')) return;
        this.upsellsList.querySelector('.bundle-title').remove();
        this.bundleParts.forEach(part => {
          const partId = part.dataset.variantId;
          this.upsellsList.querySelectorAll(`[data-upsell-id="${partId}"]`).forEach(el => el.remove());
        });

      }

      // if no upsells, hide count
      if (this.upsellsCount === 0) {
        this.upsellsCountWrapper.classList.add('hidden');
        this.upsellsDrawer.setAttribute('aria-expanded', 'false');
      }
    }

    updateStickyAtcPrice(bundlePart = false) {
      this.stickyAtcPriceArr.forEach(priceEl => {
        // get current price
        const currentPrice = this.extractMoneyValue(priceEl.innerHTML);
        let upsellPrice, newPrice = 0, combinedPrice = 0;

        if (bundlePart == false) {
          // get upsell price
          upsellPrice = this.extractMoneyValue(this.upsellPrice);
          // add or subtract upsell price
          newPrice = this.isItemAdded ? currentPrice + upsellPrice : currentPrice - upsellPrice;
        } else {
          this.bundleParts.forEach(part => {
            upsellPrice = this.extractMoneyValue(part.dataset.price);
            upsellPrice = upsellPrice * part.dataset.quantity;

            combinedPrice += upsellPrice;
          });
        }

        if (bundlePart == false) {
          // add or subtract upsell price
          newPrice = this.isItemAdded ? currentPrice + upsellPrice : currentPrice - upsellPrice;
        } else {
          newPrice = this.isItemAdded ? currentPrice + combinedPrice : currentPrice - combinedPrice;
        }

        // update price
        priceEl.innerHTML = `${this.currencySymbol}${newPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
      })

      if (this.stickyAtcSavingArr.length > 0 && this.upsellBundle == 'true') {
        // get saving amunt
        const upsellSaving = this.extractMoneyValue(this.upsellSaving);

        // check if saving is greater than 0 and update amount
        if (upsellSaving > 0) {
          this.stickyAtcSavingArr.forEach((savingEl, index) => {
            const currentSaving = savingEl.querySelector('span') ? this.extractMoneyValue(savingEl.querySelector('span').innerHTML) : 0;
            const newSaving = this.isItemAdded ? currentSaving + upsellSaving : currentSaving - upsellSaving;

            if (newSaving <= 0) {
              savingEl.innerHTML = '';
            } else {
              savingEl.innerHTML = `${window.productStrings.saving} <span>${this.currencySymbol}${newSaving.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>`;
            }

          });
        }
      }
    }

    // Extracts money value from string ex: $10.00 -> 10.00
    extractMoneyValue(inputString) {
      return Number(inputString.replace(this.currencySymbol, "").replace(/,/g, '').trim());
    }

  });
}

// Quantity Button Product Upsell

if (!customElements.get('incremental-product-upsell')) {
  customElements.define('incremental-product-upsell', class IncrementalProductUpsell extends HTMLElement {
    constructor() {
      super();
      // data
      this.upsellId = this.dataset.upsellId;
      this.upsellTitle = this.dataset.upsellTitle;
      this.upsellPrice = this.dataset.upsellPrice;
      this.upsellSaving = this.dataset.upsellSaving;
      this.currencySymbol = this.dataset.shopCurrencySymbol;
      // selectors
      this.button = this.querySelector('.upsell-quantity');
      this.buttonMinus = this.button.querySelector('button[name="minus"]');
      this.buttonPlus = this.button.querySelector('button[name="plus"]');
      this.buttonCount = this.button.querySelector('input');

      this.upsellsCountWrapper = document.querySelector('.sticky-atc__upsells')
      this.upsellsDrawer = document.querySelector('.upsells-drawer')
      this.stickyAtcPriceArr = document.querySelectorAll('.sticky-atc__price');
      this.stickyAtcSavingArr = document.querySelectorAll('.sticky-atc__saving');
      this.upsellsCountEl = this.upsellsCountWrapper.querySelector('.upsells_count')
      this.upsellsList = this.upsellsDrawer.querySelector('ul')

      // state
      this.isItemAdded = false;
      this.upsellInputCount = 0;

      // listeners
      this.buttonPlus.addEventListener('click', this.onButtonPlusClick.bind(this));
      this.buttonMinus.addEventListener('click', this.onButtonMinusClick.bind(this));

      document.addEventListener('upsells:reset', () => {
        this.reset();
      });
    }

    reset() {
      // get count
      this.upsellsCount = Number(this.upsellsCountEl.innerHTML);
      // remove hidden class
      this.upsellsCountWrapper.classList.remove('hidden')
      // update upsell count based on action
      this.upsellsCount = 0;
      // update count
      this.upsellsCountEl.innerHTML = this.upsellsCount;
      // update upsell input count
      this.upsellInputCount = 0;
      //update button count
      this.buttonCount.value = this.upsellInputCount;
      // toggle state
      if (this.upsellInputCount === 0) this.isItemAdded = false;
      // common updates
      this.updateUpsellList();
    }

    onButtonPlusClick() {
      // validate max
      if (this.buttonCount.max) {
        const value = parseInt(this.buttonCount.value);
        const max = parseInt(this.buttonCount.max);
        this.buttonPlus.classList.toggle("disabled", value >= max);
      }
      if (this.buttonPlus.classList.contains("disabled")) return;
      // get count
      this.upsellsCount = Number(this.upsellsCountEl.innerHTML);
      // remove hidden class
      this.upsellsCountWrapper.classList.remove('hidden')
      // update upsell count based on action
      this.upsellsCount = this.upsellsCount + 1;
      // update count
      this.upsellsCountEl.innerHTML = this.upsellsCount;
      // update upsell input count
      this.upsellInputCount = this.upsellInputCount + 1;
      //update button count
      this.buttonCount.value = this.upsellInputCount;
      // toggle state
      this.isItemAdded = true;
      // common updates
      this.updateUpsellList();
      this.updateStickyAtcPrice("add");
    }

    onButtonMinusClick() {
      // validate min
      if (this.buttonCount.value <= 0) return;
      // get count
      this.upsellsCount = Number(this.upsellsCountEl.innerHTML);
      // remove hidden class
      this.upsellsCountWrapper.classList.remove('hidden')
      // update upsell count based on action
      this.upsellsCount = this.upsellsCount - 1;
      // update count
      this.upsellsCountEl.innerHTML = this.upsellsCount;
      // update upsell input count
      this.upsellInputCount = this.upsellInputCount - 1;
      //update button count
      this.buttonCount.value = this.upsellInputCount;
      // toggle state
      if (this.upsellInputCount === 0) this.isItemAdded = false;
      // common updates
      this.updateUpsellList();
      this.updateStickyAtcPrice("minus");
    }

    updateUpsellList() {
      const upsellLi = this.upsellsList.querySelector(`[data-upsell-id="${this.upsellId}"]`);
      // append li or remove, also add id as data attribute
      if (this.isItemAdded && this.upsellInputCount === 1 && !upsellLi) {
        this.upsellsList.innerHTML += `<li data-upsell-quantity="1" data-upsell-price="${this.upsellPrice}" data-upsell-id="${this.upsellId}"><span class="item_count hidden">${this.upsellInputCount} x </span>${this.upsellTitle}</li>`
      } else if (this.isItemAdded && this.upsellInputCount === 1 && upsellLi) {
        upsellLi.querySelector(`.item_count`).classList.add('hidden');
        upsellLi.dataset.upsellQuantity = this.upsellInputCount;
      } else if (this.isItemAdded && this.upsellInputCount > 1) {
        upsellLi.querySelector(`.item_count`).classList.remove('hidden');
        upsellLi.querySelector(`.item_count`).innerHTML = `${this.upsellInputCount} x `;
        upsellLi.dataset.upsellQuantity = this.upsellInputCount;
      } else {
        if (upsellLi) upsellLi.remove();
        this.isItemAdded = false;
      }

      // if no upsells, hide count
      if (this.upsellsCount === 0) {
        this.upsellsCountWrapper.classList.add('hidden');
        this.upsellsDrawer.setAttribute('aria-expanded', 'false');
      }
    }

    updateStickyAtcPrice(operation = 'add') {
      // get upsell price
      const upsellPrice = this.extractMoneyValue(this.upsellPrice);

      this.stickyAtcPriceArr.forEach(priceEl => {
        // get current price
        const currentPrice = this.extractMoneyValue(priceEl.innerHTML);

        // get new price
        let newPrice = 0;
        // add or subtract upsell price
        if (operation === 'add') {
          newPrice = currentPrice + upsellPrice;
        } else {
          newPrice = currentPrice - upsellPrice;
        }
        // update price
        // priceEl.innerHTML = `${this.currencySymbol}${newPrice.toFixed(2)}`

        // format price to look like this 1,000.00 or 10,000.00
        priceEl.innerHTML = `${this.currencySymbol}${newPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
      })

      if (this.stickyAtcSavingArr.length > 0) {
        // get saving amunt
        const upsellSaving = this.extractMoneyValue(this.upsellSaving);

        // check if saving is greater than 0 and update amount
        if (upsellSaving > 0) {
          this.stickyAtcSavingArr.forEach(savingEl => {
            const currentSaving = savingEl.querySelector('span') ? this.extractMoneyValue(savingEl.querySelector('span').innerHTML) : 0;
            const newSaving = operation === 'add' ? currentSaving + upsellSaving : currentSaving - upsellSaving;
            if (newSaving <= 0) {
              savingEl.innerHTML = '';
            } else {
              savingEl.innerHTML = `${window.productStrings.saving} <span>${this.currencySymbol}${newSaving.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>`;
            }
          });
        }
      }
    }

    // Extracts money value from string ex: $10.00 -> 10.00
    extractMoneyValue(inputString) {
      return Number(inputString.replace(this.currencySymbol, "").replace(/,/g, '').trim());
    }

  });
}